import React, { useEffect, useState } from "react";
import axios from "axios";

import Input from "../../components/Input";
import InputSelect from "../../components/InputSelect";
import states from "../../seeds/states";

// Mesmos campos do menu Contato do site principal, salvos na marca. Controlado
// pela edição da marca: entra no "Salvar alterações" da página.
// Sem "Catálogo virtual": o site da marca não tem esse link no topo.
export const ContactTab = ({ contact, onChange }) => {
    const [lastCep, setLastCep] = useState('');

    const value = key => contact?.[key] ?? '';
    const set = key => val => onChange({ ...contact, [key]: val });

    useEffect(() => {
        const cep = (contact?.address_zip_code ?? '').replace(/\D/g, '');

        if (cep.length === 8 && cep !== lastCep) {
            axios.get(`https://viacep.com.br/ws/${cep}/json/`).then(res => {
                const address = res.data;
                onChange({
                    ...contact,
                    address_street: address.logradouro ?? '',
                    address_neigh: address.bairro ?? '',
                    address_city: address.localidade ?? '',
                    address_state: address.uf ?? ''
                });
            }).catch(() => {});
        }

        setLastCep(cep);
    }, [contact?.address_zip_code]);

    const generateWhatsappUrl = event => {
        event.preventDefault();
        const number = value('whatsapp_number').replace(/\D/g, '');

        if (number.length < 10) {
            alert('Preencha corretamente o número do WhatsApp antes de clicar pra gerar');
            return;
        }

        set('whatsapp_url')(`https://wa.me/55${number}`);
    };

    return (
        <div className="brand-overview brand-contact">
            <div className="brand-tab-head">
                <div>
                    <h2 className="section-title">Contato e mídias</h2>
                    <p className="section-hint">Aparecem no rodapé do site da marca.</p>
                </div>
            </div>

            <section className="brand-section">
                <h2 className="section-title">Dados da empresa</h2>
                <div className="row">
                    <div className="col-6">
                        <Input label={`Razão Social`} placeholder={`Brinde.me Ltda`} value={value('trade_name')} change={set('trade_name')} />
                    </div>
                    <div className="col-6">
                        <Input label={`CNPJ`} placeholder={`00.000.000/0001-00`} value={value('cnpj')} mask={`convertToCnpj`} change={set('cnpj')} />
                    </div>
                </div>
            </section>

            <section className="brand-section">
                <h2 className="section-title">Telefones e e-mail</h2>
                <div className="row">
                    <div className="col-3">
                        <Input label={`Número de telefone`} placeholder={`(11) 4040-4040`} value={value('telefone')} change={set('telefone')} mask={`convertToPhone`} />
                    </div>
                    <div className="col-3">
                        <Input label={`Número do WhatsApp`} placeholder={`(11) 98080-8080`} value={value('whatsapp_number')} change={set('whatsapp_number')} mask={`convertToPhone`} />
                    </div>
                    <div className="col-6">
                        <Input label={`URL para o WhatsApp`} placeholder={`https://wa.me/5511980808080`} value={value('whatsapp_url')} change={set('whatsapp_url')} />
                        <a href={`#`} onClick={generateWhatsappUrl} className="link-pos-input">Gerar url automaticamente</a>
                    </div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <Input label={`E-mail`} placeholder={`contato@suamarca.com.br`} value={value('email')} change={set('email')} />
                    </div>
                </div>
            </section>

            <section className="brand-section">
                <h2 className="section-title">Endereço</h2>
                <div className="row">
                    <div className="col-3">
                        <Input label={`CEP`} placeholder={`00000-000`} value={value('address_zip_code')} change={set('address_zip_code')} mask={`convertToCep`} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <Input label={`Logradouro`} value={value('address_street')} change={set('address_street')} />
                    </div>
                    <div className="col-3">
                        <Input label={`Número`} value={value('address_number')} change={set('address_number')} />
                    </div>
                    <div className="col-3">
                        <Input label={`Complemento`} value={value('address_complement')} change={set('address_complement')} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-4">
                        <Input label={`Bairro`} value={value('address_neigh')} change={set('address_neigh')} />
                    </div>
                    <div className="col-4">
                        <Input label={`Cidade`} value={value('address_city')} change={set('address_city')} />
                    </div>
                    <div className="col-4">
                        <InputSelect label={`Estado`} options={states} value={value('address_state')} change={set('address_state')} />
                    </div>
                </div>
            </section>

            <section className="brand-section">
                <h2 className="section-title">Redes sociais e blog</h2>
                <div className="row">
                    <div className="col-6">
                        <Input label={`Instagram`} placeholder={`https://instagram.com/exemplo`} value={value('instagram_url')} change={set('instagram_url')} />
                    </div>
                    <div className="col-6">
                        <Input label={`Facebook`} placeholder={`https://facebook.com/exemplo`} value={value('facebook_url')} change={set('facebook_url')} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <Input label={`Youtube`} placeholder={`https://youtube.com/exemplo`} value={value('youtube_url')} change={set('youtube_url')} />
                    </div>
                    <div className="col-6">
                        <Input label={`Linkedin`} placeholder={`https://linkedin.com/exemplo`} value={value('linkedin_url')} change={set('linkedin_url')} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <Input label={`Blog`} placeholder={`https://exemplo.com/blog`} value={value('blog_url')} change={set('blog_url')} />
                    </div>
                </div>
            </section>
        </div>
    );
};

export default ContactTab;
